import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function RegistrationClosedCard() {
  return (
    <Card className="bg-muted/50 border-dashed">
      <CardHeader className="text-center">
        <CardTitle className="text-muted-foreground">Registrations Closed</CardTitle>
        <CardDescription>
          We are no longer accepting new registrations for this event.
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
